import {
  MeasurementsCapabilityProvider,
  SnapType,
} from '@trimble/web3d-providers';
import lodash from 'lodash';
import {
  Accessor,
  createEffect,
  createMemo,
  createSignal,
  Setter,
} from 'solid-js';
import { CapabilityCategory } from './base/models/capability-category';
import { SharedCapabilityBase } from './base/shared-capability-base';

export class SnappingCapability extends SharedCapabilityBase {
  public category: CapabilityCategory = CapabilityCategory.Markup;

  public readonly snapTypes: Accessor<SnapType[]>;
  public readonly setSnapTypes: Setter<SnapType[]>;

  constructor(provider: MeasurementsCapabilityProvider) {
    super(provider);

    const [snapTypes, setSnapTypes] = createSignal<SnapType[]>([
      SnapType.POINT,
    ]);

    this.snapTypes = snapTypes;
    this.setSnapTypes = setSnapTypes;

    createEffect(() => {
      const viewerWrappers = this.viewerWrappers();
      const snapTypes = this.snapTypes();
      for (const viewerWrapper of viewerWrappers) {
        viewerWrapper.viewer.settings.snapTypes = snapTypes as number[];
      }
    });
  }

  public toggleSnapType(activate: boolean, snapTypes: SnapType[]): void {
    if (activate) {
      this.setSnapTypes(lodash.union(this.snapTypes(), snapTypes));
    } else {
      this.setSnapTypes(lodash.difference(this.snapTypes(), snapTypes));
    }
  }

  public setAffectPicking(_affectPicking: boolean): void {
    // No-op: snap types are global in web3d 5.0, affecting all tools including picking
  }

  public isSnapTypeActive(snapTypes: SnapType[]): Accessor<boolean> {
    // eslint-disable-next-line solid/reactivity
    return createMemo(() =>
      snapTypes.every((st) => this.snapTypes().some((s) => s == st))
    );
  }

  public cleanup(): Promise<void> {
    return Promise.resolve(undefined);
  }
}
